export default __webpack_public_path__ + "static/media/empty.237b1a1a.jpeg";